import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ColorPickerModule as NgxColorPicker } from '@iplab/ngx-color-picker';
import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ColorPickerComponent } from './color-picker.component';
import { InputColorComponent } from './input-color';

@NgModule({
    declarations: [ColorPickerComponent, InputColorComponent],
    imports: [CommonModule, FormsModule, NgxColorPicker, TwcModule, TranslateModule],
    exports: [ColorPickerComponent],
})
export class ColorPickerModule {}
